module.exports = __webpack_public_path__ + "media/images/programme-tv-20minutes-b0f4e353f61a75f95c0c8b83c863c1c8.png";